export const ORGANIZATION_NAME_MAX_LENGTH = 120
